import { useEffect } from "react";
import { useUserStore } from "store";

const LogOutComponent = () => {
    const { clearUser } = useUserStore();

    useEffect(() => {
        // Clear all auth state
        clearUser();
        localStorage.removeItem("user_access_token");
        localStorage.removeItem("terms_agree");
        localStorage.removeItem("signup_type");
        localStorage.removeItem("admin_access_token");

        // Redirect to landing page
        window.location.href = "/";
    }, []);

    return (
        <div className="flex items-center justify-center py-20">
            <div className="text-achromatic-400 text-sm">로그아웃 중...</div>
        </div>
    );
}

export default LogOutComponent;